/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_QuantityInputs */

const vi_tea_lot_quantity = /** @type {(inputs: Tea_Lot_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng (kg)`)
};

/**

* @param {Tea_Lot_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_quantity = /** @type {((inputs?: Tea_Lot_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_quantity(inputs)
});